export default {"src":"/oferta/_next/static/media/vegetarian.c8429471.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};